import { ChangeDetectionStrategy, Component, OnInit, ViewChild, AfterViewInit,ViewEncapsulation,OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import {MatPaginator} from '@angular/material/paginator';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import qnsbnurlAPI from  '../../services/qn-sbn-API-url'
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';
import { FileUploadSingleComponent } from '../fileUpload/file-upload/file-upload-single/file-upload-single.component';
const NO_DATA_FOUND_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" width="82" height="82" viewBox="0 0 82 82" fill="none">
<path d="M29.5894 54.0711C43.119 54.0711 54.0869 43.1058 54.0869 29.5794C54.0869 16.053 43.119 5.08765 29.5894 5.08765C16.0597 5.08765 5.0918 16.053 5.0918 29.5794C5.0918 43.1058 16.0597 54.0711 29.5894 54.0711Z" fill="url(#paint0_linear_6628_5860)"/>
<path d="M29.3093 0.0244317C13.1532 0.00687075 0.0410161 13.0839 0.0234552 29.24C0.00589417 45.3903 13.0947 58.4966 29.2508 58.5142C45.4127 58.5318 58.5191 45.4488 58.5366 29.2986C58.5542 13.1425 45.4713 0.0419927 29.3093 0.0244317ZM29.2566 52.5376C16.402 52.5259 5.98833 42.0947 6.00004 29.2459C6.01175 16.3913 16.4488 5.98931 29.3035 6.00102C42.1639 6.01272 52.5717 16.4381 52.56 29.2927C52.5425 42.1415 42.1171 52.5493 29.2566 52.5376Z" fill="#999999"/>
<path d="M50.9049 47.152L47.2656 50.7898L54.3963 57.9235L58.0356 54.2857L50.9049 47.152Z" fill="#999999"/>
<path d="M80.5338 80.5414C78.6197 82.4555 75.5114 82.4555 73.5972 80.5414L51.1719 58.1277L58.1143 51.1912L80.5397 73.6048C82.4538 75.5131 82.4538 78.6214 80.5338 80.5414Z" fill="url(#paint1_linear_6628_5860)"/>
<path d="M45.3715 29.5797C45.3715 29.5797 38.3062 38.2489 29.5959 38.2489C20.8857 38.2489 13.8145 29.5797 13.8145 29.5797C13.8145 29.5797 20.8798 20.9104 29.5901 20.9104C38.3003 20.9104 45.3715 29.5797 45.3715 29.5797Z" fill="white"/>
<path d="M29.5898 35.6559C32.9455 35.6559 35.6659 32.9355 35.6659 29.5798C35.6659 26.224 32.9455 23.5037 29.5898 23.5037C26.234 23.5037 23.5137 26.224 23.5137 29.5798C23.5137 32.9355 26.234 35.6559 29.5898 35.6559Z" fill="#CCCCCC"/>
<path d="M29.5904 32.9921C31.4752 32.9921 33.0031 31.4642 33.0031 29.5794C33.0031 27.6947 31.4752 26.1667 29.5904 26.1667C27.7056 26.1667 26.1777 27.6947 26.1777 29.5794C26.1777 31.4642 27.7056 32.9921 29.5904 32.9921Z" fill="#666666"/>
<defs>
<linearGradient id="paint0_linear_6628_5860" x1="12.0903" y1="12.1472" x2="46.6957" y2="46.8261" gradientUnits="userSpaceOnUse">
<stop stop-color="#CBCDD1"/>
<stop offset="1" stop-color="#E4E5EA"/>
</linearGradient>
<linearGradient id="paint1_linear_6628_5860" x1="51.1723" y1="66.5801" x2="81.9738" y2="66.5801" gradientUnits="userSpaceOnUse">
<stop stop-color="#CBCDD1"/>
<stop offset="1" stop-color="#E4E5EA"/>
</linearGradient>
</defs>
</svg>
`;
@Component({
  selector: 'dl-notification-doc',
  templateUrl: './notification-doc.component.html',
  styleUrls: ['./notification-doc.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationDocComponent implements OnInit,AfterViewInit,OnDestroy {
  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(FileUploadSingleComponent)
  private singleFileUploadComp: FileUploadSingleComponent;
  public fileData = [];
  public columnData: any;
  public displayedColumns = ['documentTitle', 'docVersion', 'docLanguage', 'docDate', 'addIcon'];
  public dataSource = new MatTableDataSource(ELEMENT_DATA);
  public selection = new SelectionModel(true, []);
  public selectedRow: any; 
  public notificationTypeFormControl= new FormControl('');
  public userFileSize = { size: 0, type: '' };
  public notificationTypeList = [
    {
      label: 'SBN',
      value: 'Safety Board Notification',
      disabled: false
    },
    {
      label: 'QN',
      value: 'Quality Notification',
      disabled: false
    },
    {
      label: 'MN',
      value: 'Marketting Notification',
      disabled: false
    },
    {
      label: 'SN',
      value: 'Support Notification',
      disabled: false
    },
    {
      label: 'SNR',
      value: 'Support Notification with Risk',
      disabled: false
    }
  ];
  isTableShow: boolean = false;
  selectedData;

  public constructor(private readonly oneSnackBar: OneSnackBarService,private readonly iconRegistry: MatIconRegistry, private readonly sanitizer: DomSanitizer,private qnsbnService: QnSbnService,private _QnSbnDataService:QnSbnDataService) {
    this.iconRegistry.addSvgIconLiteral('no_data_found', this.sanitizer.bypassSecurityTrustHtml(NO_DATA_FOUND_ICON));
    this._QnSbnDataService.DocumentEnabled$.subscribe(
      res =>{
        this.documentEnabled = res;
      } 
    )
  }
 
  public isDocumentAdded = false;
  public documentEnabled: boolean;
  public filesList = [];
  // public filesList = [
  //   {
  //     name: 'sample1.pdf',
  //     size: '50KB',
  //     fileIcon: 'file_pdf'
  //   },
  //   {
  //     name: 'sample2.xls',
  //     size: '30KB',
  //     fileIcon: 'file_excel'
  //   },
  //   {
  //     name: 'sample3.doc',
  //     size: '15KB',
  //     fileIcon: 'file_word'
  //   },
  //   {
  //     name: 'sample4.png',
  //     size: '80KB',
  //     fileIcon: 'image'
  //   }
  // ];
  public files = [];
  public searchedItem = [];
  public allDraftData = {};
  public searchDocumentControl = new FormControl();
  public dataFlag: boolean = false;
  public ngOnInit() {
    // this.dataSource.sort = this.sort;
    // this.tableData = [];
    // this.dataSource.data = this.tableData;
    // this.dataSource.paginator = this.paginator;
    this._QnSbnDataService.mappingData$.subscribe(observer=>{
      if(!this._QnSbnDataService.isEmpty(observer['notificationDoc'])) {
        this.addSearchedDocument(observer['notificationDoc']);
        this.allDraftData = observer['notificationRowData'];
      }
      
      // this.dataTobestore = observer;
    })
  }

  ngAfterViewInit(): void {  
    this.dataSource.paginator = this.paginator;
  }
  ngDoCheck(): void {
    this.addProduct(this.selectedData);
  }
  public addSearchedDocument(rowData: any,checkFromDelete?): void {
    this.selectedData = rowData;
    this.isTableShow = false;
    this.files.length = 0;
    const fileProperties = {
      name: rowData['Title'],
      size: rowData['FileSize'],
      fileIcon:rowData['FileExtension'] =='pdf'?'file_pdf':'file_word'
    };
    this.files.push(fileProperties);
    this.isDocumentAdded = true;
    this.searchDocumentControl.setValue('');
    this.notificationTypeFormControl.setValue('') 
    checkFromDelete ? this.oneSnackBar.open('Notification document successfully added', OneSnackBarType.SUCCESS) : false;

    return;
  }
  onSerach(){  
    let checkDocType = this.notificationTypeFormControl.value['label'] || ''
    let url = this.searchDocumentControl.value + "&documenttype=" + checkDocType ;
    // let url = qnsbnurlAPI.baseAPI + qnsbnurlAPI.PIOSMetadata + this.searchDocumentControl.value +"&documenttype="+this.notificationTypeFormControl.value['label'] ;
    // let url="https://qn-sbn-sandbox-lso.roche.com/api/v1/pios/metadata"+ this.searchNotificationId.value +"&documenttype="+this.notificationTypeFormControl.value['label']
    this.qnsbnService.notificationDocPiosDocSearch(url).subscribe(d=>{      
      this.files.length = 0; 
      ELEMENT_DATA = d;
      this.dataSource.data = ELEMENT_DATA;
      this.dataFlag = Array.isArray(this.dataSource.data);
      this.isTableShow = true;
      this.ngAfterViewInit();
      if(this.singleFileUploadComp){
        this.singleFileUploadComp.filesSingle.length = 0;
      }
      this.searchDocumentControl.setValue('');
      this.notificationTypeFormControl.setValue('') 
    },
    (error=>{     
      this.files.length = 0;   
      ELEMENT_DATA = [];
      this.dataSource.data = ELEMENT_DATA;
      this.dataFlag = Array.isArray(this.dataSource.data);
      this.isTableShow = true;
      this.ngAfterViewInit();
      if(this.singleFileUploadComp){
        this.singleFileUploadComp.filesSingle.length = 0;
      }
      this.searchDocumentControl.setValue('');
      this.notificationTypeFormControl.setValue('') 
      // console.log("error",error);
      this.qnsbnService.httpErrorHandler(error, 'Please Select Notification Type');
    }))
  }
  public addProduct(newData) {
    // this.addProduct(rowData);  
    this._QnSbnDataService.getMappedQnsbnData(newData,"NotificationDoc");
    return;
 }

  public deleteFile(i, file) {
    // TODO: need to integrate backend services to delete from template
    this.files = this.files.filter(item => item !== file);
    // console.log('in delete button click----->',this.files);
    const message = file.name + ' notification document successfully deleted';
    this.oneSnackBar.open(message, OneSnackBarType.SUCCESS);
    if(this.files.length < 1){
      this.selectedData = '';
    }
  }

  public downloadDocument(fileName: string, fileExtension: string) {
    const isSavedFile = this.verifyGlobalDocument(fileName);
    if(isSavedFile) {
      const notificationDoc = this.allDraftData['NotificationDocuments'];
      this.qnsbnService.downloadPiosDocumentApi(notificationDoc[0].PIMID, notificationDoc[0].FileExtension);
    } else {
      const notificationDocNew = this.selectedData;
      this.qnsbnService.downloadPiosDocumentApi(notificationDocNew.PIMID, notificationDocNew.FileExtension);
    }  
  }

  public verifyGlobalDocument(fileName: string): boolean {
    const uploadedFiles = this.allDraftData['NotificationDocuments'] || [];
    const isSavedFile = uploadedFiles.some(fileItem => fileItem.Title === fileName);
    return isSavedFile;
  }

  ngOnDestroy(): void {
    // console.log('calling on destroy methd:-');
    // this.addProduct(this.selectedData);
  }

  public bytesCalculation(bytes: number, decimals: number = 2): any {
    if (bytes === 0) {
      this.userFileSize.size = 0;
      this.userFileSize.type = '';
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    this.userFileSize.size = 0;
    this.userFileSize.type = '';

    this.userFileSize.size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    this.userFileSize.type = sizes[i];
    return this.userFileSize;
  }

  public formatBytes(bytes: number, decimals: number = 2): string {
    this.bytesCalculation(bytes, decimals);
    return this.userFileSize.size + ' ' + this.userFileSize.type;
  }

  public updateDocumentEnabled(toggle){
    this._QnSbnDataService.DocumentEnabled$.next(toggle);
    if(!toggle) {
      // Clear selected document data when disabled
      this.selectedData = '';
      this.files = [];
      this.addProduct({});
    }
  }

}let ELEMENT_DATA = [];